import { Currency } from "@redotech/money/currencies";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

const noSplitDataOutput = z.object({ splitDataExists: z.literal(false) });

const splitDataOutput = z.object({
  splitDataExists: z.literal(true),
  splitStartDate: zExt.instant(),
  splitEndDate: zExt.instant().nullable(),
  controlConversionRate: z.number(),
  treatmentConversionRate: z.number(),
  conversionRateConfidence: z.number(),
  revenuePerTargetedShopperCurrency: createEnum(Currency),
  controlRevenuePerTargetedShopper: z.number(),
  treatmentRevenuePerTargetedShopper: z.number(),
});

const output = z.union([noSplitDataOutput, splitDataOutput]);
export type Output = z.infer<typeof output>;

export const getRecentRescuePanelSplitData = {
  name: "getRecentRescuePanelSplitData" as const,
  input: z.null(),
  output,
};
